import { useLocalStorage } from '@grcs/hook/useLocalStorage';
import { getStudentSidebarLinkItems } from '@grcs/views/shared/components/navigation/SidebarLinkItems/StudentSidebarLinkItems';
import { SidebarWithHeader } from '@grcs/views/shared/components/navigation/SidebarWithHeader';
import { StudentProtectedRoute } from '../ProtectedRoute/StudentProtectedRoute';

export const StudentSidebarWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [menuLanguage] = useLocalStorage('user_language', 'en');
  const sidebarItems = getStudentSidebarLinkItems(menuLanguage);

  return (
    <StudentProtectedRoute>
      <SidebarWithHeader sidebarItems={sidebarItems}>
        {children}
      </SidebarWithHeader>
    </StudentProtectedRoute>
  );
};
